module.exports = __webpack_public_path__ + "img/ic_task management.4291cc1f.svg";